import car from "./henkilöauto.png";
import van from "./Pakettiautot.png";
import bike from "./ebike.png";
import camper from "./matkailuauto.png";
import jetSki from "./vesijetti.png";
import snowMobile from "./moottorikelkka.png";
import openTrailer from "./Avokärry.jpg";
import trailer from "./Kuomukärry.jpg";
import truck from "./Kuorma-auto.jpg";
import minibus from "./Pikkubussi.jpg";
import suv from "./maastoautot.jpg";
import minivan from "./tila-auto.jpg";

import {
  FaTruck,
  FaCarSide,
  FaCaravan,
  FaShuttleVan,
  FaTrailer,
  FaBicycle,
  FaHotTub,
  FaHotel,
  FaRegQuestionCircle,
  FaTruckMonster,
} from "react-icons/fa";

import { GiScooter } from "react-icons/gi";

import { MdAirportShuttle, MdSnowmobile } from "react-icons/md";
import {
  ADDITIONAL_FIELDS_CAR,
  ADDITIONAL_FIELDS_BICYCLE,
  ADDITIONAL_FIELDS_CAMPER,
  ADDITIONAL_FIELDS_RV,
  ADDITIONAL_FIELDS_SNOWMOBILE,
  ADDITIONAL_FIELDS_VAN,
  ADDITIONAL_FIELDS_TRAILER,
  ADDITIONAL_FIELDS_SAUNABOAT,
  ADDITIONAL_FIELDS_JETSKI,
  ADDITIONAL_FIELDS_ACCOMMODATION,
  ADDITIONAL_FIELDS_SCOOTER,
  ADDITIONAL_FIELDS_ALL,
} from "../../shared/additional-fields";

export const typeOfProducts = [
  {
    id: "product-type-accommodations",
    group: "accommodations",
    icon: <FaHotel style={{ fontSize: 28 }} />,
    additionalFields: ADDITIONAL_FIELDS_ACCOMMODATION,
    contractTemplate: false,
    nameT: {
      fi: "Majoituspaikat",
      sv: "Boenden",
      en: "Accommodations",
    },
  },
  {
    id: "product-type-bicycles",
    group: "recreationalVehicles",
    icon: <FaBicycle style={{ fontSize: 28 }} />,
    image: bike,
    additionalFields: ADDITIONAL_FIELDS_BICYCLE,
    contractTemplate: false,
    nameT: {
      fi: "Polkupyörät",
      sv: "Cyklar",
      en: "Bicycles",
    },
  },
  {
    id: "product-type-campers",
    group: "rvsCampers",
    icon: <FaCaravan style={{ fontSize: 28 }} />,
    image: null,
    additionalFields: ADDITIONAL_FIELDS_CAMPER,
    contractTemplate: false,
    nameT: {
      fi: "Matkailuvaunut",
      sv: "Husvagn",
      en: "Caravans",
    },
  },
  {
    id: "product-type-cars",
    group: "car",
    icon: <FaCarSide style={{ fontSize: 28 }} />,
    image: car,
    additionalFields: ADDITIONAL_FIELDS_CAR,
    nameT: {
      fi: "Henkilöautot",
      sv: "Personbilar",
      en: "Passenger cars",
    },
  },
  {
    id: "product-type-jetskis",
    group: "recreationalVehicles",
    icon: <MdSnowmobile style={{ fontSize: 28 }} />,
    image: jetSki,
    additionalFields: ADDITIONAL_FIELDS_JETSKI,
    contractTemplate: false,
    nameT: {
      fi: "Vesijetit",
      sv: "Vattenskoter",
      en: "Jet skis",
    },
  },
  {
    id: "product-type-minibus",
    group: "car",
    icon: <MdAirportShuttle style={{ fontSize: 28 }} />,
    image: minibus,
    additionalFields: ADDITIONAL_FIELDS_CAR,
    nameT: {
      fi: "Pikkubussi",
      sv: "Minibuss",
      en: "Minibus",
    },
  },
  {
    id: "product-type-minivan",
    group: "car",
    icon: <MdAirportShuttle style={{ fontSize: 28 }} />,
    image: minivan,
    additionalFields: ADDITIONAL_FIELDS_CAR,
    nameT: {
      fi: "Tila-auto",
      sv: "Familjebuss",
      en: "Minivan",
    },
  },
  {
    id: "product-type-other",
    icon: <FaRegQuestionCircle style={{ fontSize: 28 }} />,
    additionalFields: ADDITIONAL_FIELDS_ALL,
    contractTemplate: false,
    nameT: {
      fi: "Muut",
      sv: "Övrig",
      en: "Others",
    },
  },
  {
    id: "product-type-rvs",
    group: "rvsCampers",
    icon: <FaShuttleVan style={{ fontSize: 28 }} />,
    image: camper,
    additionalFields: ADDITIONAL_FIELDS_RV,
    contractTemplate: false,
    nameT: {
      fi: "Matkailuautot",
      sv: "Fritidsfordon",
      en: "RVs",
    },
  },
  {
    id: "product-type-saunaboats",
    group: "recreationalVehicles",
    icon: <FaHotTub style={{ fontSize: 28 }} />,
    additionalFields: ADDITIONAL_FIELDS_SAUNABOAT,
    contractTemplate: false,
    nameT: {
      fi: "Saunalautat",
      sv: "Basturaft",
      en: "Saunarafts",
    },
  },
  {
    id: "product-type-scooter",
    group: "recreationalVehicles",
    icon: <GiScooter style={{ fontSize: 28 }} />,
    additionalFields: ADDITIONAL_FIELDS_SCOOTER,
    contractTemplate: false,
    nameT: {
      fi: "Skootterit",
      sv: "Mopeder",
      en: "Scooters",
    },
  },
  {
    id: "product-type-snowmobiles",
    group: "recreationalVehicles",
    icon: <MdSnowmobile style={{ fontSize: 28 }} />,
    image: snowMobile,
    additionalFields: ADDITIONAL_FIELDS_SNOWMOBILE,
    contractTemplate: false,
    nameT: {
      fi: "Moottorikelkat",
      sv: "Snöskotrar",
      en: "Snowmobiles",
    },
  },
  {
    id: "product-type-suvs",
    group: "car",
    icon: <FaTruckMonster style={{ fontSize: 28 }} />,
    image: suv,
    additionalFields: ADDITIONAL_FIELDS_CAR,
    nameT: {
      fi: "Maastoautot",
      sv: "Terrängfordon",
      en: "SUVs",
    },
  },
  {
    id: "product-type-trailer-enclosed",
    group: "trailerVarietes",
    icon: <FaTrailer style={{ fontSize: 28 }} />,
    image: trailer,
    additionalFields: ADDITIONAL_FIELDS_TRAILER,
    nameT: {
      fi: "Kuomu- ja koppikärry",
      sv: "Stängd Trailer",
      en: "Enclosed Trailer",
    },
  },
  {
    id: "product-type-trailer-open",
    group: "trailerVarietes",
    icon: <FaTrailer style={{ fontSize: 28 }} />,
    image: openTrailer,
    additionalFields: ADDITIONAL_FIELDS_TRAILER,
    nameT: {
      fi: "Avokärry",
      sv: "Öppen Trailer",
      en: "Open Trailer",
    },
  },
  {
    id: "product-type-trailers",
    group: "trailerVarieties",
    icon: <FaTrailer style={{ fontSize: 28 }} />,
    image: trailer,
    additionalFields: ADDITIONAL_FIELDS_TRAILER,
    contractTemplate: false,
    nameT: {
      fi: "Peräkärryt",
      sv: "Släpvagnar",
      en: "Trailers",
    },
  },
  {
    id: "product-type-truck",
    group: "car",
    icon: <FaTruck style={{ fontSize: 28 }} />,
    image: truck,
    additionalFields: ADDITIONAL_FIELDS_CAR,
    nameT: {
      fi: "Kuorma-auto",
      sv: "Lastbil",
      en: "Truck",
    },
  },
  {
    id: "product-type-vans",
    group: "car",
    icon: <FaTruck style={{ fontSize: 28 }} />,
    image: van,
    additionalFields: ADDITIONAL_FIELDS_VAN,
    contractTemplate: false,
    nameT: {
      fi: "Pakettiautot",
      sv: "Transportbilar",
      en: "Vans",
    },
  },
];
